export default "__VITE_ASSET__DIstZfIW__"